const _uniqBy = require('lodash.uniqby')

const filterRelatedProjects = function (projects, page, minimum) {
  let relatedProjects = []

  // TOOD Possibly switch to lodash.filter
  // For each project from GraphQL
  projects.edges.forEach(edge => {
    if (
      edge.node.projectDetails.projectRelatedexpertise &&
      !edge.node.slug.includes('placeholder')
    ) {
      let relatedExpertise = edge.node.projectDetails.projectRelatedexpertise
      // For each related expertise
      relatedExpertise.forEach(obj => {
        // If the Expertise slugs or titles match, it’s more related

        // TODO Could improve or separate this,
        // or ideally move everything “related” to something
        // returned by the WP API
        if (obj && page) {
          if (obj.slug === page.slug || obj.title === page.title) {
            // It’s comparing and expertise to a project
            relatedProjects.push(edge)
          } else if (
            page.projectDetails &&
            page.projectDetails.projectRelatedexpertise &&
            page.projectDetails.projectRelatedexpertise.length >= 1
          ) {
            // It’s comparing a project to a project
            page.projectDetails.projectRelatedexpertise.forEach(
              potentiallyRelated => {
                if (
                  potentiallyRelated &&
                  obj.title === potentiallyRelated.title
                ) {
                  relatedProjects.push(edge)
                }
              }
            )
          }
        }
      })
    }
  })

  // Remove duplicates, esp. for project to project
  relatedProjects = _uniqBy(relatedProjects, 'node.slug')

  // TODO Check if we want to randomize on each visit
  // relatedProjects = _shuffle(relatedProjects)

  if (minimum >= relatedProjects.length) {
    relatedProjects = relatedProjects.concat(projects.edges)
  }

  return relatedProjects
}

module.exports = filterRelatedProjects
